<template>
    <div v-redirect-if-no-permission:SERVICES>
        <v-btn color="primary" dark class="mb-2 hbtn" @click="newObj">{{ $t("catalogPage.new") }}</v-btn>
        <DataTable ref="dataTable" v-if="name" :url="api.ACTIONS.SERVICE_PRICES(id)" disableSearch :titles="titles"
            :fieldsHiddenMain="['updated_at', 'service_id', 'deleted_at', 'fee']" :title='$t("catalogPage.pricesTitle", { name })'
            force-reload :actions-extra-main="actionsExtraMain" :enableEdit="false" :enableDelete="false"
            :enableAdd="false" sortBy="start_time" :formatter="formatter"
            :fieldsHiddenAdd="['updated_at', 'created_at', 'id', 'service_id', 'fee']">
        </DataTable>

        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ selectedId ? $t("catalogPage.edit") : $t("catalogPage.new") }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" :key="formKey" class="pa-4 pt-6">
                        <!-- Owner Q1: each hint states the unit and how the
                             value enters the fare (ServiceService::calculateServicePrice). -->
                        <v-text-field type="number" v-model="model.base_fare" :rules="[rules.required, rules.number]"
                            :label='$t("catalogPage.baseFare")' :hint='$t("catalogPage.baseFareHint")'
                            persistent-hint></v-text-field>
                        <v-text-field type="number" v-model="model.waiting_cost_per_min"
                            :rules="[rules.required, rules.number]" :label='$t("catalogPage.waitingCostPerMin")'
                            :hint='$t("catalogPage.waitingCostPerMinHint")' persistent-hint></v-text-field>
                        <v-text-field type="number" v-model="model.booking_cost_per_min"
                            :rules="[rules.required, rules.number]" :label='$t("catalogPage.bookingCostPerMin")'
                            :hint='$t("catalogPage.bookingCostPerMinHint")' persistent-hint></v-text-field>
                        <v-text-field type="number" v-model="model.booking_cost_per_km"
                            :rules="[rules.required, rules.number]" :label='$t("catalogPage.bookingCostPerKm")'
                            :hint='$t("catalogPage.bookingCostPerKmHint")' persistent-hint></v-text-field>
                        <v-text-field type="number" v-model="model.min_charge" :rules="[rules.required, rules.number]"
                            :label='$t("catalogPage.minCharge")' :hint='$t("catalogPage.minChargeHint")'
                            persistent-hint></v-text-field>

                        <div class="time-container d-flex justify-space-between mt-4">
                            <div>
                                <span>{{ $t("catalogPage.from") }}</span><br />
                                <v-time-picker v-model="model.start_time"></v-time-picker>
                            </div>

                            <div>
                                <span>{{ $t("catalogPage.to") }}</span><br />
                                <v-time-picker v-model="model.end_time"></v-time-picker>
                            </div>
                        </div>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">{{ $t("catalogPage.close") }}</v-btn>
                    <v-btn color="blue darken-1" :loading="loading" flat @click="save">{{ $t("catalogPage.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";


export default {
    name: "ServicePrices",
    title() {
        return this.$t("catalogPage.pageTitlePrices");
    },
    components: { DataTable },
    data() {
        return {
            formKey: 0,
            id: null,
            name: null,
            dialog: false,
            loading: false,
            selectedId: null,
            model: {
                base_fare: null,
                waiting_cost_per_min: null,
                booking_cost_per_min: null,
                booking_cost_per_km: null,
                min_charge: null,
                // A new band covers the whole day by default (owner Q1): a
                // band saved with untouched times used to cover the morning
                // only, hiding the service from riders after midday.
                start_time: "00:00",
                end_time: "23:59"
            }

        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.name = this.$route.query.name || this.$t("catalogPage.unknown");
    },
    methods: {
        newObj() {
            this.formKey++;
            this.selectedId = null;
            this.model.base_fare = null;
            this.model.waiting_cost_per_min = null;
            this.model.booking_cost_per_min = null;
            this.model.booking_cost_per_km = null;
            this.model.min_charge = null;
            this.model.start_time = "00:00";
            this.model.end_time = "23:59";
            this.dialog = true;
        },
        save() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            if (this.model.end_time <= this.model.start_time) {
                window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("catalogPage.enterValidHours"),
                    "red"
                );
                this.loading = false;

                return;
            }
            if (this.selectedId) {
                this.axios
                    .put('price/' + this.selectedId, {
                        ...this.model
                    })
                    .then(() => {
                        window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.updatedSuccessfully"), "green");
                        this.$refs.dataTable.getData();
                        this.dialog = false;
                    })
                    .catch((err) => {
                        console.log(err.message);
                        this.error = true;
                        let response = err.response;
                        if (response) {
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                            console.log(response.data);
                        } else {
                            window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.checkYourInfo"), "red");
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
            } else {
                this.axios
                    .post('price', {
                        ...this.model, service_id: this.id
                    })
                    .then(() => {
                        window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.createdSuccessfully"), "green");
                        this.$refs.dataTable.getData();
                        this.dialog = false;
                    })
                    .catch((err) => {
                        console.log(err.message);
                        this.error = true;
                        let response = err.response;
                        if (response) {
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                            console.log(response.data);
                        } else {
                            window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.checkYourInfo"), "red");
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
            }

        }
    },
    computed: {
        rules() {
            return {
                length: (len) => (v) =>
                    (v || "").length >= len || this.$t("catalogPage.ruleLength", { len }),
                required: (v) => !!v || this.$t("catalogPage.ruleRequired"),
                number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("catalogPage.rulePositiveNumber")
            }
        },

        actionsExtraMain() {
            return {

                editPrice: {
                    icon: 'edit',

                    action: (item) => {
                        this.selectedId = item.id;
                        this.model.base_fare = item.base_fare;
                        this.model.waiting_cost_per_min = item.waiting_cost_per_min;
                        this.model.booking_cost_per_min = item.booking_cost_per_min;
                        this.model.booking_cost_per_km = item.booking_cost_per_km;
                        this.model.min_charge = item.min_charge;
                        this.model.start_time = item.start_time;
                        this.model.end_time = item.end_time;
                        this.dialog = true;
                    }

                },

                delete: {
                    icon: 'delete',
                    action: (item) => {
                        this.$dialova({
                            title: this.$t("catalogPage.deleteRowTitle"),
                            paragraph: this.$t("catalogPage.deleteRowConfirm"),
                            loader: true,
                        })
                            .then(({ close }) => {
                                this.axios
                                    .delete(`price/` + item.id)
                                    .then(() => {
                                        window.getApp.$emit(
                                            "SHOW_TOAST",
                                            this.$t("catalogPage.rowDeleted"),
                                            "green"
                                        );
                                        this.$refs.dataTable.getData();
                                        close();
                                    })
                                    .catch((err) => {
                                        window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("catalogPage.errorOccurred"), "red");
                                        close();
                                    });
                            })
                            .catch(() => {
                                console.log("cancelled");
                            });
                    }
                }
            }
        },
        titles() {
            return {
                "id": "#",
                "created_at": this.$t("catalogPage.colCreationDate"),
                'base_fare': this.$t("catalogPage.colBaseFare"),
                'waiting_cost_per_min': this.$t("catalogPage.colWaitingCostPerMin"),
                "booking_cost_per_min": this.$t("catalogPage.colBookingCostPerMin"),
                "booking_cost_per_km": this.$t("catalogPage.colBookingCostPerKm"),
                "min_charge": this.$t("catalogPage.colMinCharge"),
                "start_time": this.$t("catalogPage.colStartTime"),
                "end_time": this.$t("catalogPage.colEndTime")
            }
        },
        formatter() {
            return {

                created_at(value) {
                    return formatCompanyTime(value, "YYYY-MM-DD");
                }
            }
        },

    }
}
</script>

<style>
.time-container {
    display: flex;
}

.time-left,
.time-right {
    flex: 1;
    padding: 10px;
}

.auto-dialog .v-overlay__content {
    width: auto !important;
}

.auto-card {
    display: inline-block;
}

.hbtn {
    float: inline-end;
    z-index: 1;
    margin-top: 20px;
    margin-inline-end: 20px;
    padding: 0px 45px;
}
</style>
